import React from "react";

const WhatsAppButton = () => {
  const phoneNumber = "+491737951785"; // 🔁 change to your number
  const message = "Hello, I need help with an order.";

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      style={styles.button}
    >
      💬
    </a>
  );
};

const styles = {
  button: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    backgroundColor: "#25D366",
    color: "white",
    fontSize: "30px",
    padding: "15px",
    borderRadius: "50%",
    textDecoration: "none",
    boxShadow: "0 4px 10px rgba(0,0,0,0.3)",
    zIndex: 1000,
  },
};

export default WhatsAppButton;
